import React, { useEffect } from 'react';
import styles from './BetLines.module.scss';
import commonStyles from '../BetSlip.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { BET_SLIP_TABS } from '../../../constants/defaultValues';
import SingleBetLine from './SingleBetLine';
import ComboBetLine from './ComboBetLine';
import SystemBetLine from './SystemBetLine';
import { getTranslation } from '../../../utils/translation';
import { setSocketContext } from '../../../store/actions/socketAction';

const BetLines = props => {
    const dispatch = useDispatch();

    const betLines = useSelector(state => state.betSlip.betLines);
    const activeBetSlipTab = useSelector(state => state.betSlip.activeTab);

    useEffect(() => {
        const formattedBetLines = betLines.map(betLine => betLine.eventId);

        dispatch(setSocketContext({ betLines: formattedBetLines }));
    }, [betLines.length]);

    return (
        <div className={commonStyles.betSlipBody}>
            {betLines.length > 0 ? (
                betLines.map(bet => {
                    if (activeBetSlipTab === BET_SLIP_TABS.single.id) {
                        return (
                            <SingleBetLine
                                key={`${bet.eventId}-${bet.marketId}-${bet.outcomeId}`}
                                bet={bet}
                            />
                        );
                    } else if (activeBetSlipTab === BET_SLIP_TABS.combo.id) {
                        return (
                            <ComboBetLine
                                key={`${bet.eventId}-${bet.marketId}-${bet.outcomeId}`}
                                bet={bet}
                            />
                        );
                    } else if (activeBetSlipTab === BET_SLIP_TABS.system.id) {
                        return (
                            <SystemBetLine
                                key={`${bet.eventId}-${bet.marketId}-${bet.outcomeId}`}
                                bet={bet}
                            />
                        );
                    }
                })
            ) : (
                <h2 className={styles.emptyMessage}>{getTranslation('betSlip.emptyMessage')}</h2>
            )}
        </div>
    );
};

export default BetLines;
